import { SERVER_BASE_URL } from '../../config';
import { DashboardFilters } from './types';

// installAuthFetch attaches the Supabase JWT to these URLs automatically.
export function adminUrl(
  path: string,
  params: Record<string, string | boolean | null | undefined> = {}
): string {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== null && v !== undefined && v !== '') q.set(k, String(v));
  });
  const s = q.toString();
  return `${SERVER_BASE_URL}/api/admin/${path}${s ? `?${s}` : ''}`;
}

export function filterParams(filters: DashboardFilters): Record<string, string | null> {
  return {
    from: filters.from,
    to: filters.to,
    chart: filters.chart,
    orientation: filters.orientation,
    language: filters.language,
  };
}
